import React, { useState } from 'react';
import { Menu, MenuItem, ListItemText, Box, TextField, InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import PropTypes from 'prop-types';

export default function FavoriteDashboardSearch(props) {
  const { dashboards, anchorEl, setAnchorEl } = props;
  const [searchQuery, setSearchQuery] = useState('');

  function handleClose() {
    setAnchorEl(null);
  }

  const filteredDashboards = dashboards.filter((dashboard) => dashboard.name.toLowerCase().includes(searchQuery.toLowerCase()));

  return (
    <Menu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={handleClose}
      className="favdashboard-search-menu"
      slotProps={{
        paper: {
          sx: {
            width: '400px',
            maxHeight: '520px',
            overflowY: 'hidden',
            marginLeft: '5px',
            marginTop: '4px'
          }
        }
      }}
    >
      <Box sx={{ paddingRight: '4px', paddingLeft: '8px', paddingBottom: '2px', marginTop: '-3px' }}>
        <TextField
          fullWidth
          sx={{
            height: '29px',
            WebkitTapHighlightColor: '#aaaaaa !important',
            '& .MuiOutlinedInput-root': {
              height: '29px',
              WebkitTapHighlightColor: '#aaaaaa !important',
              '& input': {
                padding: '5px',
                WebkitTapHighlightColor: '#aaaaaa !important'
              },
              '& fieldset': {
                borderColor: '#aaaaaa !important',
                borderStyle: 'solid',
                borderWidth: '1px !important'
              },
              '&:hover fieldset': {
                borderColor: '#aaaaaa !important',
                borderWidth: '1px !important'
              },
              '&.Mui-focused fieldset': {
                borderColor: '#aaaaaa !important',
                borderWidth: '1px !important'
              },
              '&.Mui-disabled fieldset': {
                borderColor: '#aaaaaa !important',
                borderWidth: '1px !important'
              },
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: '#aaaaaa !important',
                borderWidth: '1px !important'
              }
            }
          }}
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          InputProps={{
            notched: false,
            endAdornment: (
              <InputAdornment position="end">
                <SearchIcon color="#888888" style={{ width: '17px', marginRight: '-11px' }} />
              </InputAdornment>
            )
          }}
        />
      </Box>

      <Box sx={{ maxHeight: '238px', overflowY: 'auto', marginBottom: '-8px' }}>
        {filteredDashboards.map((dashboard, index) => (
          <MenuItem
            key={index}
            className="custom-menu-item"
            onClick={() => (window.location.href = `/dashboard/${dashboard.id}`)}
            sx={{
              alignItems: 'flex-start',
              paddingTop: '10px',
              paddingBottom: '10px',
              marginLeft: '12px',
              display: 'flex',
              borderBottom: '0.1px solid #ccc',
              '&:last-child': {
                borderBottom: 'none'
              }
            }}
          >
            <ListItemText
              sx={{
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                display: 'block',
                color: '#455a64cc',
                marginLeft: '-12px',
                marginRight: '-3px'
              }}
              primaryTypographyProps={{ fontSize: '14px', lineHeight: 'normal' }}
              primary={dashboard.name}
            />
          </MenuItem>
        ))}
      </Box>
    </Menu>
  );
}

FavoriteDashboardSearch.propTypes = {
  dashboards: PropTypes.array.isRequired,
  anchorEl: PropTypes.object,
  setAnchorEl: PropTypes.func.isRequired
};
